import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FilmCard } from '../components/FilmCard';
import { filmProjects } from '../data/films';

export function renderFilmsPage(): string {
  const filmCardsHtml = filmProjects.map(f => FilmCard(f)).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Films Hero Header -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(249, 115, 22, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(249, 115, 22, 0.2);">
        <div style="position: absolute; inset: 0; opacity: 0.18; pointer-events: none;">
          <img src="/images/brand/atomix-film-banner.jpg" alt="AtomixFilms Cinema Studio" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 850px;">
          <div class="badge badge-orange" style="margin-bottom: 1rem;">
            <sl-icon name="film"></sl-icon>
            <span>AtomixFilms Division</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            AI Cinema, Drama Series & <span class="text-gradient-orange">Short Films</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.6; margin-bottom: 2rem;">
            Pioneering generative AI cinematography, dramatic serialized storytelling, and viral high-impact shorts on YouTube and TikTok. Where imagination meets neural filmmaking.
          </p>

          <div style="display: flex; justify-content: center; gap: 1rem; flex-wrap: wrap;">
            <a href="https://youtube.com/@atomixchannel" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
              <sl-icon name="youtube"></sl-icon>
              <span>Watch on YouTube</span>
            </a>
            <a href="https://tiktok.com/@atomixchannel" target="_blank" rel="noopener noreferrer" class="btn-ghost">
              <sl-icon name="tiktok"></sl-icon>
              <span>Follow on TikTok</span>
            </a>
          </div>
        </div>
      </section>

      <!-- AI Cinema Capabilities Highlights -->
      <section class="container" style="padding: 4.5rem 1.5rem 2rem;">
        <div class="grid grid-3" style="gap: 1.5rem;">
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #f97316;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🎬</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Generative Sci-Fi Worlds</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Deep space exploration, cyberpunk metropolises, and surreal planetary landscapes visualized with multi-modal video diffusion models.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #ef4444;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">🎭</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Dramatic Episodic Series</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              Character-driven drama, mystery, and thriller storylines featuring consistent AI character generation and emotive voice acting.
            </p>
          </div>
          <div class="glass-panel" style="padding: 1.75rem; border-top: 3px solid #eab308;">
            <div style="font-size: 1.8rem; margin-bottom: 0.75rem;">📱</div>
            <h3 style="font-size: 1.2rem; margin-bottom: 0.5rem;">Viral Mobile Shorts</h3>
            <p style="font-size: 0.9rem; color: #94a3b8; line-height: 1.6;">
              High-retention micro-stories, surreal fractal animations, and audio-reactive visuals tuned for TikTok and YouTube Shorts algorithms.
            </p>
          </div>
        </div>
      </section>

      <!-- Films Catalog -->
      <section class="container" style="padding: 3.5rem 1.5rem 5rem;">
        <div class="section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <span class="badge badge-orange" style="margin-bottom: 0.5rem;">Screenings & Premieres</span>
          <h2 style="font-size: 2rem;">Short Films & Drama Releases</h2>
          <p style="margin: 0;">Explore our productions currently streaming across YouTube and TikTok.</p>
        </div>
        <div class="grid grid-2">
          ${filmCardsHtml}
        </div>
      </section>

    </main>

    ${Footer()}
  `;
}
